import React, { useState } from 'react';
import { Button, Header, Image, Modal } from 'semantic-ui-react'
import headphonesMicSpeaker from '../assets/headphones-mic-speaker.jpg'
import './modal-helper.css'

const defPromptObj = {
  image: headphonesMicSpeaker,
  modal_header: 'Warning - Unsaved Data',
  header_text: 'Complete Entry/edit?',
  description_text: <div><p>
    You have unsaved data.
  </p>
    <p>Save Data, Overwrite or Cancel?</p></div>,
  button_neg_text: 'Cancel',
  button_pos_text: "Overwrite",
  button_save_text: "Save"
}

function UtilityModal({ isOpen, promptObj, handleCancel, handleOverwrite, handleSave, handleModalClose }) {
  const [open, setOpen] = useState(false);
  let prompts = promptObj ? promptObj : defPromptObj;
  return (
    <Modal
      onClose={handleModalClose}
      onOpen={() => setOpen(true)}
      open={isOpen}
    >
      <Modal.Header>{prompts.modal_header}</Modal.Header>
      <Modal.Content image>
        <Image size='medium' src={prompts.image} wrapped />
        <Modal.Description>
          <Header>{prompts.header_text}</Header>
          {prompts.description_text}
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handleCancel}>
          {prompts.button_neg_text}
        </Button>
        <Button
          negative
          content={prompts.button_pos_text}
          onClick={handleOverwrite}
        />
        <Button positive
          content={prompts.button_save_text}
          onClick={handleSave} >
        </Button>
      </Modal.Actions>
    </Modal>
  )
}
export default UtilityModal;
